import React from 'react';
import PropTypes from 'prop-types';

/**
 * Training Progress Bar Component
 * Shows progress with animated gradient bar
 */
const TrainingProgressBar = ({ progress, showLabel = true, height = 'h-3' }) => {
  const percentage = Math.min(100, Math.max(0, progress));

  return (
    <div className="w-full">
      {showLabel && (
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm font-medium text-gray-700">
            Прогресс обучения
          </span>
          <span className="text-sm font-semibold text-blue-600">
            {percentage}%
          </span>
        </div>
      )}

      <div className={`w-full bg-gray-200 rounded-full overflow-hidden ${height}`}>
        <div
          className="h-full bg-gradient-to-r from-blue-500 to-purple-600 transition-all duration-500 ease-out rounded-full"
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin="0"
          aria-valuemax="100"
        >
          {percentage > 15 && (
            <div className="h-full flex items-center justify-end pr-2">
              <span className="text-xs font-bold text-white">
                {percentage}%
              </span>
            </div>
          )}
        </div>
      </div>

      {percentage === 100 && (
        <div className="mt-2 text-center">
          <span className="inline-flex items-center gap-1 text-sm font-medium text-green-600">
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Обучение завершено!
          </span>
        </div>
      )}
    </div>
  );
};

TrainingProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  showLabel: PropTypes.bool,
  height: PropTypes.string,
};

export default TrainingProgressBar;
